<script setup lang="ts">
  import { computed } from 'vue';
  import { IconImage } from '@/shared/ui';
  import ModalUploadIcon from '@/shared/assets/icons/ModalUploadIcon.svg';

  const props = defineProps<{
    isDragging: boolean;
    onDragEnter: (e: DragEvent) => void;
    onDragLeave: (e: DragEvent) => void;
    onDragOver: (e: DragEvent) => void;
    onDrop: (e: DragEvent) => void;
    openFileDialog: () => void;
    multiple: boolean;
  }>();

  const text = {
    header: {
      multiple: 'Arraste seus arquivos para cá',
      single: 'Arraste seu arquivo para cá',
    },
    button: {
      multiple: 'Pesquisar arquivos',
      single: 'Pesquisar arquivo',
    },
    description: {
      multiple: 'Você pode arrastar seus arquivos para esta área ou buscá-los clicando abaixo',
      single: 'Você pode arrastar seu arquivo para esta área ou buscá-lo clicando abaixo',
    },
  };

  const dropzoneClasses = computed(() => [
    'border border-dashed rounded-xl p-10 flex flex-col justify-center items-center gap-5',
    props.isDragging
      ? 'border-[var(--theme-secondary-ink)] bg-[var(--theme-secondary-tint)]'
      : 'border-gray-02 bg-[var(--theme-secondary-tint-subtle)]',
  ]);
</script>

<template>
  <div
    id="document-dropzone-wrapper"
    :class="dropzoneClasses"
    @dragenter="onDragEnter"
    @dragleave="onDragLeave"
    @dragover="onDragOver"
    @drop="onDrop"
  >
    <IconImage
      :src="ModalUploadIcon"
      alt="Upload"
      class="text-[var(--theme-secondary-ink)]"
    />
    <h2 class="text-[var(--theme-secondary-ink)] text-xl font-semibold">
      {{ text.header[props.multiple ? 'multiple' : 'single'] }}
    </h2>
    <p class="text-gray-07 w-4/13 text-center text-sm">
      {{ text.description[props.multiple ? 'multiple' : 'single'] }}
    </p>
    <button
      type="button"
      class="text-[var(--theme-secondary-ink)] underline text-sm"
      @click="openFileDialog"
    >
      {{ text.button[props.multiple ? 'multiple' : 'single'] }}
    </button>
  </div>
</template>
